var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPath4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.461 255.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "maskPath",
    d: "M2874.227,8810s-34.474,40.07-14.935,49.054,60.638-46.377,112.292-55.36,218.521-70.407,278.484-94.325,118.355-79.951,108.586-100.276",
    transform: "translate(-2850.29 -8607.792)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "maskReveal",
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M2874.227,8810s-34.474,40.07-14.935,49.054,60.638-46.377,112.292-55.36,218.521-70.407,278.484-94.325,118.355-79.951,108.586-100.276",
    transform: "translate(-2850.29 -8607.792)",
    fill: "none",
    stroke: "#ff4b4b",
    strokeWidth: 6,
    strokeDasharray: "8 5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath4);
export default __webpack_public_path__ + "static/media/path-4.5137de7f.svg";
export { ForwardRef as ReactComponent };